import React from "react";
import { StyledTooltip } from "../../InputMol.styled";
var Tooltip = function Tooltip(_ref) {
  var content = _ref.content;
  return /*#__PURE__*/React.createElement(StyledTooltip, null, content);
};
export default Tooltip;